<div class="m-multi-row d-flex flex-column justify-content-lg-start  justify-content-sm-center text-right"
	[formGroup]="income">
	<div class="d-flex flex-column justify-content-lg-start  justify-content-sm-center text-right ">
		<!-- <div class="form-row mx-auto my-2 py-4 m-row-income" [formGroup]="income" style="width: 90%"> -->
		<button type="button" *ngIf="displayX" class="close" aria-label="Close" (click)="removed.emit(index)">
			<span aria-hidden="true">&times;</span>
		</button>
		<div class="form-row row">
			<div class="form-group col-12 col-md-6 input-wrapper pr-0 w-100 mt-3">
				<!-- <div *ngIf="index===0" class="text-right m-title">
				{{titles[0] | translate}}
			</div>
			<select formControlName="type" [attr.id]="'type'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[0]|translate">
				<option [value]="defaultValue">{{ph}}</option>
				<option *ngFor="let option of type" [value]="option">{{option}}</option>
			</select>
			<div class="m-error" *ngIf="income.get('type').hasError('required') && displayErrors">
				{{ 'COMMON.FIELD_REQUIRED_FROM_LIST' | translate }}
			</div> -->
				<label class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{titles[0] |
					translate}}</label>

				<app-dplist-new (onToggleItems)="clickInput.emit(index)" (onSelectItem)="changeInput.emit(index)"
					[valueArr]='type' formControlName="type">
				</app-dplist-new>
				<!-- <label class="m-error text-right" *ngIf="userDetails.get('maritalStatus').hasError('required') && submitted">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label> -->
				<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
					*ngIf="income.get('type').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' |
					translate }}</label>
			</div>
			<div class="form-group col-12 col-md-6">
				<!-- <div class="row" *ngIf="income.get('type').value === 'אחר' && needSources ">
				<div class="col-12 col-md-6 mt-3"> -->

				<!-- <app-animated-input formControlName="amount" [type]="'text'" [attrId]="'liabilityBalance'+index" placeholder="{{ titles[1] | translate }}" [attAriaLabel]="titles[1]|translate" attrId="{{'liabilityBalance'+index}}" [hasCurrencyMask]="true" [animatedLabel]="false" [hasTitle]="true"></app-animated-input> -->

				<!-- <label  class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{ titles[1] | translate }}</label>
					<input currencyMask type="text" class="app-input" formControlName="amount"  [attr.aria-label]="titles[1]|translate"
					[attr.id]="'liabilityBalance'+index"  /> -->
				<!-- <label class="app-error d-flex justify-content-center justify-content-md-start mr-md-2 mr-0" *ngIf="income.get('amount').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="income.get('amount').hasError('min') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label> -->


				<!-- <div *ngIf="index===0" class="text-right m-title">
						{{ titles[1] | translate }}
					</div>
					<input currencyMask type="tel" formControlName="amount" [attr.id]="'amount'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[1]|translate"/>
					<div class="m-error" *ngIf="income.get('amount').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('amount').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div> -->
				<!-- </div>


				<div class="col-12 col-md-6 input-wrapper mt-3">

					<app-animated-input formControlName="source" [type]="'text'" [attrId]="'liabilityBalance'+index" placeholder="{{ titles[2] | translate }}" [attAriaLabel]="titles[1]|translate" attrId="{{'liabilityBalance'+index}}" [hasCurrencyMask]="false" [animatedLabel]="false" [hasTitle]="true"></app-animated-input> -->
				<!-- <label  class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{ titles[2] | translate }}</label>

					<input  type="text" class="app-input" formControlName="source"  [attr.aria-label]="titles[1]|translate"
					[attr.id]="'liabilityBalance'+index"/> -->
				<!-- <label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="(income.get('source').hasError('required') && displayErrors) || (showErrorOtherIncomes && !income.get('source').hasError('required') && displayErrors)">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0" *ngIf="income.get('source').hasError('min') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' | translate }}</label> -->

				<!-- <div *ngIf="index===0" class="text-right m-title">
						{{ titles[2] | translate }}
					</div>
					<input type="text" formControlName="source" [attr.id]="'source'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[2]|translate"/>
					<div class="m-error" *ngIf="income.get('source').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('source').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div> -->
				<!-- </div>
			</div> -->
				<div class="input-wrapper mt-3">


					<app-animated-input formControlName="amount" [type]="'text'" [attrId]="'liabilityBalance'+index"
						placeholder="{{ titles[1] | translate }}" [attAriaLabel]="titles[1]|translate"
						attrId="{{'liabilityBalance'+index}}" [isDisabled]="isDisabled" [hasCurrencyMask]="true"
						[animatedLabel]="false" [hasTitle]="true"></app-animated-input>
					<!-- <label  class="text-title app-font-size-xxs app-font-regular m-0 text-right pr-2">{{ titles[1] | translate }}</label>

				<input currencyMask type="text" class="app-input" formControlName="amount" [ngClass]="isDisabled ? 'disabled-color': 'enabled-color'" [attr.aria-label]="titles[1]|translate"
				[attr.id]="'liabilityBalance'+index"  /> -->
					<label class="app-error d-flex justify-content-center justify-content-md-start mr-md-2 mr-0"
						*ngIf="income.get('amount').hasError('required') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' |
						translate }}</label>
					<label class="app-error d-md-flex text-center text-md-right mr-md-2 mr-0"
						*ngIf="income.get('amount').hasError('min') && displayErrors">{{ 'COMMON.FIELD_REQUIRED' |
						translate }}</label>


					<!-- <div *ngIf="index===0" class="text-right m-title">
							{{ titles[1] | translate }}
					</div>
					<input currencyMask type="tel" formControlName="amount" [attr.id]="'amount'+index" class="form-control m-sm-form-control" [attr.aria-label]="titles[1]|translate"
					/>
					<div class="m-error" *ngIf="income.get('amount').hasError('required') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div>
					<div class="m-error" *ngIf="income.get('amount').hasError('min') && displayErrors">
						{{ 'COMMON.FIELD_REQUIRED' | translate }}
					</div> -->
				</div>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/line-other-income/line-other-income.component.html